import Immutable from 'immutable';
import {
  FLAG_GETTING_IDENTIFICATION_TYPES,
  SHOW_ERROR_GETTING_IDENTIFICATION_TYPES,
  CLEAR_ERROR_GETTING_IDENTIFICATION_TYPES,
  GET_IDENTIFICATION_TYPES,
  CLEAR_IDENTIFICATION_TYPES,
} from '../../../actions/types';
import { COLLECTION_SHAPE } from '../../../config/shapes';


const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    error: null,
    loading: false,
  }),
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FLAG_GETTING_IDENTIFICATION_TYPES:
      return state.setIn(['all', 'loading'], action.payload);
    case SHOW_ERROR_GETTING_IDENTIFICATION_TYPES:
      return state.setIn(['all', 'error'], action.payload);
    case CLEAR_ERROR_GETTING_IDENTIFICATION_TYPES:
      return state.deleteIn(['all', 'error']);
    case GET_IDENTIFICATION_TYPES:
      return state.setIn(['all', 'content'], Immutable.Map(action.payload));
    case CLEAR_IDENTIFICATION_TYPES:
      return state.setIn(['all', 'content'], Immutable.Map(COLLECTION_SHAPE));
    default:
      return state;
  }
};
